import { alpha, color } from "metabase/lib/colors";
import styled from "@emotion/styled";
import { space } from "metabase/styled-components/theme";
import Button from "metabase/core/components/Button";
import BaseDateUnitSelector from "./DateUnitSelector";
import BaseNumericInput from "metabase/components/NumericInput";
export const DateUnitSelector = styled(BaseDateUnitSelector)`
  button:focus {
    border-color: ${({ primaryColor = color("brand") }) => primaryColor};
  }
`;
export const NumericInput = styled(BaseNumericInput)`
  &:focus {
    border-color: ${({ primaryColor = color("brand") }) => primaryColor};
  }
`;
export const CurrentButton = styled(Button)`
  border: none;
  border-radius: 99px;

  background-color: ${({ selected, primaryColor = color("brand") }) => selected ? primaryColor : alpha(primaryColor, 0.1)};
  color: ${({ selected, primaryColor = color("brand") }) => selected ? "white" : primaryColor};

  padding-top: ${space(1)};
  padding-bottom: ${space(1)};

  &:hover {
    color: white;
    background-color: ${(props) => props.primaryColor || color("brand")};
  }
`;
export const CurrentContainer = styled.div`
  display: flex;
  flex-wrap: no-wrap;
  grid-gap: ${space(2)};
  margin-bottom: ${({ first }) => first ? space(2) : ""};
`;
export const CurrentPopover = styled.div`
  color: ${color("white")};
  background-color: ${color("black")};
  padding: ${space(1)} ${space(2)};
`;
export const OptionsContainer = styled.div`
  background-color: ${color("white")};
  padding: ${space(2)} ${space(1)};
`;
export const OptionButton = styled(Button)`
  display: block;
  border: none;

  .Icon {
    transform: ${({ reverseIconDirection }) => reverseIconDirection ? "rotate(180deg)" : ""};
  }

  color: ${({ selected, primaryColor = color("brand") }) => selected ? primaryColor : color("text-dark")};

  &:hover {
    color: ${({ primaryColor = color("brand") }) => primaryColor};
    background: none;
  }
`;
export const MoreButton = styled(Button)`
  border: none;
  color: ${color("text-medium")};

  &:hover {
    color: ${({ primaryColor = color("brand") }) => primaryColor};
  }
`;
export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(${({ numColumns = 3 }) => numColumns}, auto);
  justify-content: start;
  align-items: center;
  grid-gap: ${space(1)};
`;
export const GridText = styled.div`
  font-size: 1em;
  color: ${color("text-medium")};
`;
